var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-flex",
    {
      attrs: {
        column: "",
        role: "region",
        "aria-label": "Landing page content",
      },
    },
    [
      _c("zushin-cover"),
      _vm._v(" "),
      _c(
        "v-card",
        { attrs: { flat: "" } },
        [
          _c(
            "v-layout",
            {
              class: {
                column: _vm.$vuetify.breakpoint.mdAndDown,
                row: _vm.$vuetify.breakpoint.lgAndUp,
              },
              attrs: {
                wrap: "",
                role: "region",
                "aria-label": "Zushin updates section",
              },
            },
            [
              _c(
                "v-flex",
                {
                  attrs: {
                    xs12: "",
                    sm12: "",
                    md12: "",
                    lg6: "",
                    "justify-center": "",
                  },
                },
                [
                  _c("carsousel", {
                    attrs: {
                      items: _vm.notes,
                      "has-effect": true,
                      "aria-label": "Notes carousel",
                      role: "region",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                {
                  attrs: {
                    xs12: "",
                    sm12: "",
                    md12: "",
                    lg6: "",
                    "justify-center": "",
                  },
                },
                [
                  _c("carsousel", {
                    attrs: {
                      items: _vm.events,
                      "has-effect": true,
                      "aria-label": "Events carousel",
                      role: "region",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                {
                  attrs: {
                    xs12: "",
                    sm12: "",
                    md12: "",
                    lg12: "",
                    "justify-center": "",
                  },
                },
                [
                  _c("carsousel", {
                    attrs: {
                      items: _vm.guides,
                      "has-effect": false,
                      "aria-label": "Guides carousel",
                      role: "region",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _vm.notes.length === 0
                ? _c(
                    "v-flex",
                    {
                      attrs: {
                        xs12: "",
                        sm12: "",
                        md12: "",
                        lg6: "",
                        "justify-center": "",
                      },
                    },
                    [
                      _c(
                        "v-card",
                        [
                          _c(
                            "v-card-actions",
                            [
                              _c(
                                "v-flex",
                                {
                                  staticClass:
                                    "align-middle justify-middle text-center column height",
                                },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        large: "",
                                        icon: "",
                                        "aria-label": "Loading notes",
                                        role: "status",
                                      },
                                    },
                                    [
                                      _c("v-icon", [
                                        _vm._v("fal fa-circle-notch fa-spin"),
                                      ]),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "v-flex",
                {
                  attrs: {
                    xs12: "",
                    sm12: "",
                    md12: "",
                    lg6: "",
                    "justify-center": "",
                  },
                },
                [
                  _vm.events.length === 0
                    ? _c(
                        "v-card",
                        [
                          _c(
                            "v-card-actions",
                            [
                              _c(
                                "v-flex",
                                {
                                  staticClass:
                                    "align-middle justify-middle text-center column height",
                                },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        large: "",
                                        icon: "",
                                        "aria-label": "Loading events",
                                        role: "status",
                                      },
                                    },
                                    [
                                      _c("v-icon", [
                                        _vm._v("fal fa-circle-notch fa-spin"),
                                      ]),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                {
                  attrs: {
                    xs12: "",
                    sm12: "",
                    md12: "",
                    lg12: "",
                    "justify-center": "",
                  },
                },
                [
                  _vm.guides.length === 0
                    ? _c(
                        "v-card",
                        [
                          _c(
                            "v-card-actions",
                            [
                              _c(
                                "v-flex",
                                {
                                  staticClass:
                                    "align-middle justify-middle text-center column height",
                                },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        large: "",
                                        icon: "",
                                        "aria-label": "Loading guides",
                                        role: "status",
                                      },
                                    },
                                    [
                                      _c("v-icon", [
                                        _vm._v("fal fa-circle-notch fa-spin"),
                                      ]),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("posts", {
        attrs: {
          posts: _vm.posts,
          "is-loading": _vm.isListsLoading,
          role: "region",
          "aria-label": "Latest Zushin posts",
        },
      }),
      _vm._v(" "),
      _c(
        "v-parallax",
        {
          staticClass: "pt-10",
          attrs: {
            dark: "",
            src: "https://gm.goz.fun/wp-content/uploads/2023/03/review-cover.png",
            "aria-label": "Reviews and Ads section",
            role: "region",
          },
        },
        [
          _c(
            "v-layout",
            { staticClass: "row", attrs: { wrap: "" } },
            [
              _c(
                "v-flex",
                {
                  attrs: {
                    xs12: "",
                    sm12: "",
                    md12: "",
                    lg6: "",
                    "justify-center": "",
                  },
                },
                [_c("review-card")],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                {
                  attrs: {
                    xs12: "",
                    sm12: "",
                    md12: "",
                    lg6: "",
                    "justify-center": "",
                  },
                },
                [_c("ad-carousel")],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.canHideRegistrationForm
        ? _c(
            "v-parallax",
            {
              staticClass: "pt-10",
              attrs: {
                dark: "",
                src: "https://gm.goz.fun/wp-content/uploads/2023/03/rapid-register-cover.png",
                "aria-label": "Rapid registration section",
                role: "region",
              },
            },
            [
              _c(
                "v-layout",
                { staticClass: "row", attrs: { wrap: "" } },
                [
                  _c(
                    "v-flex",
                    {
                      attrs: {
                        xs12: "",
                        sm12: "",
                        md12: "",
                        lg12: "",
                        "justify-center": "",
                      },
                    },
                    [
                      _c("rapid-register-form", {
                        on: {
                          onFinishedRegistration: _vm.onFinishedRegistration,
                          onStartedRegistration: _vm.onStartedRegistration,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }